export default [
  {
    title:  'Geofences Plans',
    icon: 'ClipboardIcon',
    name:'dashboard',
    tagVariant: 'light-warning',
    children: [
      {
        title: 'Garden Plan',
        name: 'gplans.garden.index',
        route: 'gplans.garden.index',
        icon: 'ClipboardIcon',
        meta: {
          module: 'gplans.garden'
        }
      },
    ],
  },
]
